interface Write {
  isError: boolean;
  error: unknown;
  reset: () => void;
}

/**
 * The one refusal a group of writes shows. A write's refusal stays until that
 * same write runs again, so starting any write forgets the others' refusals;
 * otherwise a refused confirm sits beside a later edit that succeeded.
 */
export function latestRefusal(writes: readonly Write[]) {
  return {
    refused: writes.find((write) => write.isError),
    /** Forget every other write's refusal, then run this one when it is given. */
    starting: (write: Write, run?: () => void) => {
      for (const other of writes) if (other !== write) other.reset();
      run?.();
    },
  };
}
